import { createSelector } from '@reduxjs/toolkit';
import { getTermValue } from '../../../packages/JsonQuery';
import { selectJsonQuery } from './selectJsonQuery';

export const selectIsByCommercialOwner = createSelector(selectJsonQuery, jsonQuery =>
  getTermValue('is_by_commercial_owner')(jsonQuery),
);
